import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';

import {ApplicationContextConsumer, bindLoadingHandler, LoadingOverlayHandler} from '../app/ApplicationContext';
import {ClientSummary, ErrorResponse} from '../api/dtos/dtos';
import * as paths from '../paths';
import {ErrorAlert} from '../common/ErrorAlert';
import {InvoiceEntry} from "../api/dtos/summaries";
import {InvoiceSource} from "./invoice";
import InvoiceEditor from "./InvoiceEditor";

interface LocationState {
  client?: ClientSummary;
  year?: number;
  month?: number;
  source: InvoiceSource;
  sourceId?: number;
  entries?: InvoiceEntry[];
  invoiceComment?: string;
}

interface State extends LocationState {
  error?: ErrorResponse;
}

class CreateInvoicePage extends React.Component<RouteComponentProps<paths.IdPageUrlParams, {}, LocationState>, State> {
  public readonly loadingHandler?: LoadingOverlayHandler;

  constructor(props: RouteComponentProps<paths.IdPageUrlParams, {}, LocationState>) {
    super(props);
    this.state = {
      ...this.props.location.state,
    };
  }

  public render(): React.ReactNode {
    const {error} = this.state;

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <InvoiceEditor
          editable={true}
          client={this.state.client}
          year={this.state.year}
          month={this.state.month}
          source={this.state.source}
          sourceId={this.state.sourceId}
          entries={this.state.entries}
          invoiceComment={this.state.invoiceComment}
          onCancel={this.pop}
          onSubmit={this.viewInvoiceDetails}
        />


        <ErrorAlert style={{marginTop: 16}} error={error}/>
      </>
    );
  }

  private pop = () => {
    this.props.history.goBack();
  }

  private viewInvoiceDetails = (id: number) => {
    this.props.history.replace(paths.viewInvoicePath(id));
  }

}

export default withRouter(CreateInvoicePage);




// WEBPACK FOOTER //
// ./src/invoicing/CreateInvoicePage.tsx